import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter'
import {SelectFilterProvider} from '@github-ui/filter/providers'
import {CheckCircleIcon} from '@primer/octicons-react'

export class RuleStatusFilterProvider extends SelectFilterProvider {
  constructor() {
    super(
      {
        displayName: 'Rule status',
        key: 'rule-status',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: CheckCircleIcon,
        description: 'Rule status: all | pass | fail | bypass',
      },
      [
        {value: 'all', displayName: 'All statuses', priority: 1},
        {value: 'pass', displayName: 'Pass', priority: 2},
        {value: 'fail', displayName: 'Fail', priority: 3},
        {value: 'bypass', displayName: 'Bypass', priority: 4},
      ],
      {
        filterTypes: {
          exclusive: false,
          valueless: false,
          hasValue: false,
          multiKey: false,
          multiValue: false,
        },
      },
    )
  }
}
